module.exports = __webpack_public_path__ + "img/fushimi-HP-006.41e28cdf.jpg";